import Component from '../../lib/component'

export default class PollReleaseLegacyComponent extends Component {
    static selector () {
        return '.poll-release-legacy'
    }

    constructor (opts) {
        super(opts)

        this.render()
    }

    isProgressiveTextTables () {
        return this.props.progressiveTextTables === 'true'
    }

    getPollReleaseQuestions () {
        return this.el.querySelector('.poll-release-questions')
    }

    renderQuestions (arr) {
        const questions = this.getPollReleaseQuestions()

        const itemsTag = questions.tagName.match(/(ul|ol)/i)
            ? 'li'
            : 'div'

        const items = arr
            .map((str, idx) => {
                const el = document.createElement('div')

                el.innerHTML = str
                    .replace(/<!-- name:\s(.+)\s-->/, '')

                Array.from(el.querySelectorAll('pre'))
                    .filter(_el => _el.parentElement !== el)
                    .forEach(_el => {
                        const parent = Array.from(el.children)
                            .filter(parentEl => parentEl.contains(_el))[0]

                        if (parent.classList.contains('QChart'))
                            _el.classList.add('poll-release-questions-table')

                        if (parent.classList.contains('TChart'))
                            _el.classList.add('poll-release-questions-table-trend')

                        _el.innerHTML = _el.innerHTML
                            .split('\n')
                            .map(str => (str.match(/^TREND:/)
                                        && !str.match(/\s{2,}/))
                                    || (str.match(/^\S/)
                                        && str.match(/<br>/))
                                ? ''
                                : str)
                            .join('\n')

                        el.insertBefore(_el, parent)

                        if (!parent.children.length)
                            parent.remove()
                    })

                return ({
                    legacyHash: str
                        .split(/\s-->/)[0]
                        .replace(/<!--\sname:\s(.+)/, '$1'),
                    str: el.innerHTML
                        .replace(/(<br>\s*)/g, '\n')
                })
            })
            .map((obj, idx) => {
                const el = document.createElement('div')
                el.innerHTML = obj.str

                const inlineTags = [
                    'a', 'abbr', 'acronym', 'b', 'bdo', 'big', 'br', 'em', 'i',
                    'q', 'small', 'span', 's', 'strong', 'sub', 'sup', 'time', 'u'
                ]

                const els = Array.from(el.children)
                    .filter(_el => inlineTags
                        .indexOf(_el.tagName.toLowerCase()) < 0)

                const parts = []

                els
                    .forEach((_el, _idx) => {
                        const _elParts = !_idx
                            ? obj.str.split(_el.outerHTML)
                            : parts[parts.length - 1].split(_el.outerHTML)

                        if (!_idx)
                            parts.push(_elParts[0])

                        if (_idx)
                            parts[parts.length - 1] = _elParts[0]

                        parts.push(_el.outerHTML)
                        parts.push(_elParts[1])
                    })

                return ({
                    legacyHash: obj.legacyHash,
                    arr: parts
                        .map(str => !str.match(/^</)
                            ? str.split(/\n+/g)
                                .filter(_str => _str.trim())
                            : [str])
                        .filter(arr => arr.length)
                        .reduce((acc, curr) => acc.concat(curr), [])
                })
            })
            .map((obj, idx) => obj.arr
                .map(str => str.trim())
                .filter(str => str)
                .map(str => {
                    const heading = (str.match(/^(\d+([^.])*)\s*/) || [])[1]

                    if (!heading)
                        return str

                    return `
                        <h3
                            id="question-${heading}-heading"
                            class="poll-release-questions-item-heading sticky-bar heading-6"
                            data-sticky-disabled="false"
                            data-unstick-parent-bounds-bottom="true"
                            data-breakpoints='{"1024":{"stickyDisabled":true}}'
                        >
                            <a
                                href="#question-${heading}"
                                ${obj.legacyHash
                                    && `data-hash-alias="${obj.legacyHash}"`}
                            >
                                <span class="text-screen-reader">Question</span>
                                ${str}
                            </a>
                        </h3>`
                        .replace(/\n|\s{2,}/g, ' ')
                })
                .map(str => str.match(/^</)
                    ? str
                    : `<p>${str.split(/\n/g)
                        .filter(_str => _str.trim())
                        .join('\n')}</p>`)
                .join('\n'))
            .map((str, idx) => {
                const id = (str.match(/href="#(question-[^"]+)/) || [])[1]

                const idAttr = id
                    ? ` id="${id}"`
                    : ''

                return `<${itemsTag}${
                    idAttr} class="poll-release-questions-item" tabindex="-1">${
                    str}</${itemsTag}>`
            })

        questions.innerHTML = items.join('\n')

        Array.from(questions.children)
            .forEach((el, idx) => {
                Array.from(el.children)
                    .filter(_el => _el.tagName !== 'PRE')
                    .forEach(_el => {
                        _el.innerHTML = _el.innerHTML.trim()
                    })

                Array.from(el.querySelectorAll(':empty'))
                    .forEach(_el => _el.remove())

                if (el.id)
                    Array.from(el.querySelectorAll('p'))
                        .filter(_el => _el.innerText.match(/^\s*trend:/i))
                        .forEach((_el, _idx) => {
                            _el.id = `${el.id}-trend-label-${_idx}`

                            let nextSibling = _el.nextElementSibling

                            while (nextSibling && nextSibling.tagName === 'PRE') {
                                nextSibling.setAttribute('aria-labelledby', _el.id)
                                nextSibling = nextSibling.nextElementSibling
                            }
                        })

                Array.from(el.querySelectorAll('pre'))
                    .forEach(_el => {
                        if (!_el.getAttribute('aria-labelledby')
                                && el.id)
                            _el.setAttribute('aria-labelledby',
                                el.id)

                        if (!this.isProgressiveTextTables())
                            return

                        _el.classList
                            .add('progressive-text-table')
                    })
            })

        Array.from(questions.children)
            .forEach((el, idx) => {
                if (!idx
                        || !el.children
                        || el.children[0].tagName === 'H3'
                        || (el.children[1]
                                && el.children[1].tagName !== 'H3'))
                    return

                questions.children[idx - 1]
                    .appendChild(el.children[0])
            })
    }

    renderTextBlockContentTail (html = '') {
        if (html.match(/<\/table>/)
                && !html.match(/<table>/))
            html = `<table>${html}`

        const div = document.createElement('div')

        div.className = 'container pad-section pad-0-b'
        div.innerHTML = html

        const children = Array.from(div.children)

        if (!children.length)
            return

        children
            .forEach((el, idx) => {
                if (el.tagName === 'BR')
                    return el.remove()

                if (!idx
                        && el.tagName === 'A'
                        && el.name
                        && !el.href) {
                    const h2 = document.createElement('h2')

                    h2.innerHTML = el.innerHTML
                        .replace(/:\s*$/, '')
                        .trim()

                    div.insertBefore(h2, el)

                    return el.remove()
                }

                if (el.tagName === 'TABLE') {
                    const ul = document.createElement('ul')

                    div.insertBefore(ul, el)

                    const rows = Array.from(el.querySelectorAll('tr'))

                    rows
                        .forEach((_el, _idx) => {
                            const li = document.createElement('li')

                            if (_idx !== rows.length - 1)
                                li.className = 'margin-1-b'

                            Array.from(_el.children)
                                .forEach(col => {
                                    if (!col.children.length) {
                                        const p = document.createElement('p')
                                        p.innerHTML = col.innerHTML
                                        p.className = 'margin-0-b'
                                        return li.appendChild(p)
                                    }

                                    li.innerHTML += `${col.innerHTML}<br>`
                                })

                            li.innerHTML = li.innerHTML.replace(/<br>$/, '')

                            ul.appendChild(li)
                        })

                    return el.remove()
                }
            })

        Array.from(div.querySelectorAll('a[target="_new"]'))
            .forEach(el => {
                el.setAttribute('target', '_blank')
                el.setAttribute('title', 'Opens in New Tab')
            })

        div.innerHTML
            = `<div class="text-block"><div class="text-block-content">${
                div.innerHTML}</div></div>`

        this.el.appendChild(div)
    }

    renderTextBlockContent (parentEl, html = '') {
        if (!parentEl)
            return

        let isUppercaseHeadings = true

        const inlineTags = [
            'a', 'abbr', 'acronym', 'b', 'bdo', 'big', 'br', 'em', 'i',
            'q', 'small', 'span', 's', 'strong', 'sub', 'sup', 'time', 'u'
        ]

        const nodes = html
            .replace(/(<\/(?:ul|ol|blockquote)>)/mg, '$1\n<br><br>')
            .replace(/(<(?:ul|ol|blockquote)>)/mg, '<br><br>\n$1')
            .replace(/^\s*?(Visit.+)(\s*<br>\s*<br>\s*)(^\s*[A-Z])/m,
                '$1<br>$3')
            .split(/<br>\s*<br>/g)
            .map(str => str.trim())
            .filter(str => str)
            .map(str => {
                if (!str.match(/^</)
                        && !str.match(/\n/)
                        && !str.match(/<br>/)
                        && !str.match(/[.:;?!"]$/)
                        && !str.match(/(\.com|\.edu)/)) {
                    const text = str.replace(/(&[^;]+;)/g, '')

                    isUppercaseHeadings = !text.match(/[a-z]/)

                    return `<h2>${str}</h2>`
                }

                str = str
                    .replace(/target="_new"/g,
                        'target="_blank" title="Opens in New Tab"')

                const div = document.createElement('div')
                div.innerHTML = str

                const children = Array.from(div.children)

                children
                    .filter(el => el.tagName === 'A'
                        && el.hash)
                    .forEach(el => div.removeChild(el))

                const isBlockChild = children
                    .map(el => el.tagName.toLowerCase())
                    .filter(tag => inlineTags.indexOf(tag) < 0)
                    .length

                return !isBlockChild
                    ? `<p>${div.innerHTML}</p>`
                    : (children.length === 1
                        ? div.innerHTML
                        : div.outerHTML)
            })

        if (isUppercaseHeadings)
            this.props.uppercaseHeadings = 'true'

        parentEl.innerHTML = nodes.join('\n')
    }

    render () {
        const code = this.el.querySelector('code')

        if (!code || !this.getPollReleaseQuestions())
            return

        code.style.display = 'none'

        const el = document.createElement('div')

        el.innerHTML = code.innerHTML
            .replace(/(<!--|-->)/g, '')

        const parts = el.innerHTML
            .replace(/^(<a\sname=")(question\d+)("><\/a>)/igm,
                '$1$2$3<!-- name: $2 -->')
            .split(/^<a\sname="question\d+"><\/a>/im)

        if (!parts || !parts.length)
            return

        const isTailText = !parts[parts.length - 1]
            .match(/^\s*(\d+([^.])*)\s*/)

        this.renderTextBlockContent(code.parentElement, parts[0])

        this.renderQuestions(parts.slice(1, isTailText
            ? parts.length - 1
            : parts.length))

        if (isTailText)
            this.renderTextBlockContentTail(parts[parts.length - 1])

        if (this.isProgressiveTextTables())
            Array.from(this.el
                .querySelectorAll('pre:not(.progressive-text-table)'))
                .forEach(el => el.classList.add('progressive-text-table'))

        el.remove()
        code.remove()
    }
}
